enum PromotionTypes {
  AfterTaxPromo = 'AfterTaxPromo',
}

export default PromotionTypes;
